import Header from "../components/header";
import PricingHolder from '../components/pricing-holder';
import TextHolder from "../components/text-holder";
import { useEffect,useState } from "react";
import { fetchPaymentDetails } from "../functions/fetchPaymentDetails";

function PaymentPage(){
    const [checkOutUrl,SetCheckOutURL] = useState(null);
    useEffect(async() => {
        let details = await fetchPaymentDetails();
        let url = `${process.env.REACT_APP_BACKEND_URL}/create-checkout-session?email=${details.email}&auth=${details.auth}`;
        SetCheckOutURL(url);
      }, []);
    return <>
    <Header URLForLogo='/'></Header>
    <TextHolder heading="Want to upgrade to a paid account?" smallText="Check our simple monthly and yearly pricing options, cancellable at any time!" />
    <PricingHolder subscription={true} checkOutUrl={checkOutUrl} />
    </>
}
    
export default PaymentPage;